import { message } from 'antd';
import { isErrorHandled } from '@shared/services/base-api.service';

export function handleApiError(
  error: any,
  defaultMessage: string = 'Đã xảy ra lỗi',
  showError: boolean = true
): void {
  if (isErrorHandled(error)) {
    return;
  }

  if (showError) {
    message.error(error?.message || defaultMessage);
  }
}
